import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ProcedureItem } from 'src/app/models/ProcedureItem';
import { select, Store } from '@ngrx/store';
import { getCurrentPractice } from '../../../practices/state/selectors';
import { takeWhile } from 'rxjs/operators';
import { getCurrencies } from '../../../state/selectors';
import { FullPayment } from '../../../models/FullPayment';
import { Observable, Subscription } from 'rxjs';
import { Practice } from '../../../models/Practice';
import { Currency } from '../../../models/Currency';
import { AppState } from '../../../state/reducers';

@Component({
  selector: 'procedure-item',
  templateUrl: './procedure-item.component.html',
  styleUrls: ['./procedure-item.component.scss']
})
export class ProcedureItemComponent implements OnInit, OnDestroy {
  @Input() item?: ProcedureItem;
  alive = true;
  practice$?: Observable<Practice | null>;
  practiceSub$?: Subscription;
  practice?: Practice | null;
  currencies: Currency[] = [];
  practiceCurrency?: Currency;

  constructor(private store: Store<AppState>) { }

  ngOnInit(): void {
    this.subscribeToCurrentPractice();
    this.subscribeToCurrencies();
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

  subscribeToCurrentPractice(): void {
    this.practice$ = this.store.pipe(select(getCurrentPractice)).pipe(
      takeWhile(() => this.alive)
    );

    this.practiceSub$ = this.practice$.subscribe((practice) => {
      this.practice = practice;
      this.setPracticeCurrency();
    });
  }

  subscribeToCurrencies(): void {
    this.store.pipe(select(getCurrencies)).pipe(
      takeWhile(() => this.alive)
    ).subscribe(currencies => {
      this.currencies = currencies;
      this.setPracticeCurrency();
    });
  }

  setPracticeCurrency(): void {
    if (this.currencies.length && this.practice) {
      this.practiceCurrency = this.currencies.find((currency) => currency.currencyCode === this.practice?.currency);
    }
  }
}
